module.exports = __webpack_public_path__ + "media/images/landing_page/viesi-1bd90d04d08a06562f3031be922cfa3f.png";